let sidebarInitialized = false;

function getLoomlyAiUiState() {
  const sidebar = document.getElementById('loomly-ai-sidebar');
  const body = document.getElementById('loomly-ai-body');
  const open = body?.classList.contains('chat-open') || false;
  return {
    loomly_ai_ui_enabled: document.body.dataset.loomlyAiUiEnabled === 'true',
    loomly_ai_enabled: document.body.dataset.loomlyAiFeaturesEnabled === 'true',
    sidebar_expanded: sidebar?.dataset.expanded === 'true',
    open,
    is_side_chat: open && new URL(window.location).searchParams.has('chat_id')
  };
}

window.getLoomlyAiUiState = getLoomlyAiUiState;

const LAI_COMPACT_MIN = 992;  // below this the nav rail becomes an off-canvas drawer
const LAI_DESKTOP_MIN = 1200; // at/above this the user's expand/collapse preference wins

// Pick the rail state from viewport width. Below compact the rail is a drawer that shows
// full labels (data-expanded=true) and is hidden off-canvas via CSS; between compact and
// desktop it auto-collapses to the icon rail; above desktop the stored preference wins.
function applySidebarMode(sidebar) {
  if (!sidebar) return;
  const w = window.innerWidth;
  if (w < LAI_COMPACT_MIN) {
    sidebar.dataset.expanded = 'true';
  } else if (w < LAI_DESKTOP_MIN) {
    sidebar.dataset.expanded = 'false';
  } else {
    const stored = localStorage.getItem('loomly-ai-sidebar-expanded');
    sidebar.dataset.expanded = stored !== null ? stored : 'true';
  }
}

function syncDrawerToggleAria(open) {
  const btn = document.querySelector('.js-loomly-ai-drawer-toggle');
  if (!btn) return;
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  btn.setAttribute('aria-label', open ? 'Close navigation menu' : 'Open navigation menu');
}

function closeLoomlyAiDrawer() {
  const body = document.getElementById('loomly-ai-body');
  const wasOpen = body?.classList.contains('lai-drawer-open');
  body?.classList.remove('lai-drawer-open');
  syncDrawerToggleAria(false);
  // Closing the drawer also dismisses the calendar switcher panel it hosts, so the panel
  // isn't left floating (e.g. after Escape, which the panel's own handlers don't catch).
  if (wasOpen) {
    const panel = document.getElementById('loomly-ai-calendar-panel');
    if (panel && panel.dataset.visible === 'true') {
      panel.dataset.visible = 'false';
      document.querySelector('.js-calendar-panel-toggle')?.classList.remove('active');
    }
  }
}

function toggleLoomlyAiDrawer() {
  const body = document.getElementById('loomly-ai-body');
  if (!body) return;
  const open = body.classList.toggle('lai-drawer-open');
  if (open) ensureLoomlyAiDrawerBackdrop();
  syncDrawerToggleAria(open);
}

function ensureLoomlyAiDrawerBackdrop() {
  const body = document.getElementById('loomly-ai-body');
  if (!body || document.getElementById('loomly-ai-drawer-backdrop')) return;
  const backdrop = document.createElement('div');
  backdrop.id = 'loomly-ai-drawer-backdrop';
  backdrop.addEventListener('click', closeLoomlyAiDrawer);
  body.appendChild(backdrop);
}

let loomlyAiShellListenersBound = false;
function initLoomlyAiShellListeners() {
  if (loomlyAiShellListenersBound) return;
  loomlyAiShellListenersBound = true;

  let resizeScheduled = false;
  window.addEventListener('resize', () => {
    if (resizeScheduled) return;
    resizeScheduled = true;
    requestAnimationFrame(() => {
      resizeScheduled = false;
      applySidebarMode(document.getElementById('loomly-ai-sidebar'));
      if (window.innerWidth >= LAI_COMPACT_MIN) closeLoomlyAiDrawer();
    });
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.js-loomly-ai-drawer-toggle')) {
      e.preventDefault();
      toggleLoomlyAiDrawer();
      return;
    }
    // Following a nav link closes the drawer so the destination isn't hidden behind it.
    if (window.innerWidth < LAI_COMPACT_MIN && e.target.closest('#loomly-ai-sidebar a.loomly-ai-nav-link')) {
      closeLoomlyAiDrawer();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.getElementById('loomly-ai-body')?.classList.contains('lai-drawer-open')) {
      closeLoomlyAiDrawer();
    }
  });

  // Leave a clean snapshot for Turbo's cache: close the drawer and drop the injected
  // backdrop so a restored page re-injects a fresh one with its click handler.
  document.addEventListener('turbo:before-cache', () => {
    closeLoomlyAiDrawer();
    document.getElementById('loomly-ai-drawer-backdrop')?.remove();
  });
}

function initLoomlyAiSidebar() {
  const sidebar = document.getElementById('loomly-ai-sidebar');
  if (!sidebar) return;

  initLoomlyAiShellListeners();
  ensureLoomlyAiDrawerBackdrop();
  applySidebarMode(sidebar);

  if (sidebar.dataset.initialized === 'true') return;
  sidebar.dataset.initialized = 'true';

  const toggle = sidebar.querySelector('.loomly-ai-sidebar-toggle');
  if (!toggle) return;

  const storageKey = 'loomly-ai-sidebar-expanded';

  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const isExpanded = sidebar.dataset.expanded === 'true';
    const newState = !isExpanded;
    sidebar.dataset.expanded = newState.toString();
    localStorage.setItem(storageKey, newState.toString());

    if (window.trackPicoUserAction) {
      window.trackPicoUserAction('sidebar_toggled', getLoomlyAiUiState());
    }
  });
}

// --- Social Listening notification dot ---

let slSubscription = null;
let slSubscribedCalendarId = null;
let slUnseenCheckedCalendarId = null;
let slHasNotification = false;

function showSlNotificationDot(navItem) {
  slHasNotification = true;
  if (navItem) navItem.classList.add('has-notification');
}

function hideSlNotificationDot(navItem) {
  slHasNotification = false;
  if (navItem) navItem.classList.remove('has-notification');
}

function fetchSlUnseenStatus(calendarId) {
  fetch(`/calendars/${calendarId}/social_listening/unseen_status`, {
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json' }
  })
    .then((r) => r.json())
    .then((data) => {
      if (calendarId !== slUnseenCheckedCalendarId) return;
      const navItem = document.getElementById('loomly-ai-sl-nav-item');
      if (data.has_unseen) {
        showSlNotificationDot(navItem);
      } else {
        hideSlNotificationDot(navItem);
      }
    })
    .catch(() => { slUnseenCheckedCalendarId = null; });
}

function initSlNotificationDot() {
  const navItem = document.getElementById('loomly-ai-sl-nav-item');
  if (!navItem) return;

  const calendarId = navItem.dataset.slCalendarId;
  if (!calendarId) return;

  if (slUnseenCheckedCalendarId === calendarId) {
    if (slHasNotification) {
      showSlNotificationDot(navItem);
    } else {
      hideSlNotificationDot(navItem);
    }
    subscribeToSlChannel(calendarId);
    return;
  }

  slUnseenCheckedCalendarId = calendarId;
  fetchSlUnseenStatus(calendarId);

  subscribeToSlChannel(calendarId);
}

function subscribeToSlChannel(calendarId) {
  if (slSubscribedCalendarId === calendarId && slSubscription) return;

  if (slSubscription) {
    slSubscription.unsubscribe();
    slSubscription = null;
    slSubscribedCalendarId = null;
  }

  if (!window.App?.cable) return;

  slSubscription = window.App.cable.subscriptions.create(
    { channel: 'SocialListeningCalendarChannel', id: calendarId },
    {
      received(data) {
        if (data.type !== 'run_updated') return;

        const run = data.run;
        if (!run) return;

        const navItem = document.getElementById('loomly-ai-sl-nav-item');
        if (!navItem) return;

        if (run.status === 'completed' && !run.seen_at) {
          showSlNotificationDot(navItem);
          return;
        }

        if (run.seen_at) {
          fetchSlUnseenStatus(calendarId);
        }
      }
    }
  );
  slSubscribedCalendarId = calendarId;
}

document.addEventListener('turbo:visit', () => {
  if (slSubscription) {
    slSubscription.unsubscribe();
  }
  slSubscription = null;
  slSubscribedCalendarId = null;
  slUnseenCheckedCalendarId = null;
});

document.addEventListener('turbo:load', initLoomlyAiSidebar);
document.addEventListener('DOMContentLoaded', initLoomlyAiSidebar);
document.addEventListener('turbo:load', initSlNotificationDot);
document.addEventListener('DOMContentLoaded', initSlNotificationDot);

function syncTopbarNewPostLink() {
  const topbarLink = document.querySelector('#js-top-navbar .loomly-ai-topbar-new-post');
  const sidebarLink = document.querySelector('#loomly-ai-sidebar a[data-loomly-ai-new-post-link]');
  if (!topbarLink) return;

  const href = sidebarLink?.getAttribute('href');
  if (href && href !== '#') {
    topbarLink.setAttribute('href', href);
    topbarLink.hidden = false;
  } else {
    topbarLink.hidden = true;
  }
}

document.addEventListener('turbo:load', syncTopbarNewPostLink);
document.addEventListener('DOMContentLoaded', syncTopbarNewPostLink);

document.addEventListener('turbo:frame-load', (event) => {
  if (event.target?.id !== 'loomly-ai-main-frame') return;
  if (window.innerWidth < LAI_COMPACT_MIN) closeLoomlyAiDrawer();
  initLoomlyAiSidebar();
  initSlNotificationDot();
  syncTopbarNewPostLink();
});
